module.exports = __webpack_public_path__ + "static/media/yoga.e8627962.svg";